module.exports = __webpack_public_path__ + "static/media/Renee Anderson.fb08e2a6.png";